import React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
  ToastAnnouncement,
} from 'components/core';
import { Inline } from 'components/layout';

type Props = {
  isOpen: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onKeepEditing: () => void;
};

// Below 800px this is a dialog within a dialog: Headless UI sends Escape to
// the top-most one, and the criteria sheet sits at z 97/98 so this modal's
// 99/100 surfaces stack above it.
const UnsavedChangesModal = ({
  isOpen,
  onSave,
  onDiscard,
  onKeepEditing,
}: Props) => (
  <Modal
    size="md"
    isOpen={isOpen}
    onClose={onKeepEditing}
    aria-label="Unsaved changes"
  >
    <ModalHeader>Unsaved changes</ModalHeader>
    <ModalBody>
      <Text>You have unsaved changes to your Eligibility Criteria.</Text>
      <Text>Save them before closing?</Text>
    </ModalBody>
    <ModalFooter>
      <Inline alignX="right" spacing={2}>
        <Button type="neutral" variant="outline" onClick={onDiscard}>
          Discard
        </Button>
        <Button type="brand" onClick={onSave}>
          Save
        </Button>
      </Inline>
    </ModalFooter>
    <ToastAnnouncement />
  </Modal>
);

export default UnsavedChangesModal;
